import { gql } from '@apollo/client';
import { CORE_SAVED_SEARCH_FIELDS } from '@general/graphql/fragments/saved-searches';

export const SAVED_SEARCHES_QUERY = gql`
    ${CORE_SAVED_SEARCH_FIELDS}
    query {
        savedSearches {
            ...CoreSavedSearchFields
        }
    }
`;

export const ADD_SAVED_SEARCH = gql`
    mutation AddSavedSearch(
        $title: String!
        $default: Boolean
        $primaryInterest: PrimaryInterest!
        $businessLocations: [BusinessLocation]!
        $tenants: TenancyProfileInput
        $space: TenancyProfileInput
        $connections: ConnectionsProfileInput
        $products: ProductsProfileInput
    ) {
        addSavedSearch(
            title: $title
            default: $default
            primaryInterest: $primaryInterest
            businessLocations: $businessLocations
            tenants: $tenants
            space: $space
            connections: $connections
            products: $products
        ) {
            id
            title
            primaryInterest
            default
            isComplete
            createdAt
        }
    }
`;

export const UPDATE_SAVED_SEARCH = gql`
    mutation UpdateSavedSearch(
        $id: ID
        $title: String!
        $default: Boolean
        $primaryInterest: PrimaryInterest!
        $businessLocations: [BusinessLocation]!
        $tenants: TenancyProfileInput
        $space: TenancyProfileInput
        $connections: ConnectionsProfileInput
        $products: ProductsProfileInput
    ) {
        updateSavedSearch(
            id: $id
            default: $default
            title: $title
            primaryInterest: $primaryInterest
            businessLocations: $businessLocations
            tenants: $tenants
            space: $space
            connections: $connections
            products: $products
        ) {
            id
            title
            primaryInterest
            isComplete
            createdAt
        }
    }
`;

export const REMOVE_SAVED_SEARCH = gql`
    mutation RemoveSavedSearch($id: ID) {
        removeSavedSearch(id: $id) {
            id
        }
    }
`;
